<div class="col-lg-12 col-md-12 col-12" style="padding-top: 100px;">
    <div class="bk-title--default text-center mb--70">
         <h6 class="heading heading-h6 theme-color"></h6>
         <div class="bkseparator--30"></div>
         <h3 class="heading heading-h3">Activador Akashico® Luz Ilimitada<sup>®</sup> Practicante </h3>
     </div>
     <div class="row">
        
         <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/5521485876.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Paola Solís Jiménez</li>
                     <li>pao3004@hotmail.com</li>
                     <li>TEL. 5521485876</li>
                     <li>Puebla, Puebla</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
          <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9981473510.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Nedda Fosado</li>
                     <li>nedda09@yahoo.com.mx</li>
                     <li>Tel. 9981473510</li>
                     <li>Puerto Morelos, Quintana Roo</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
         <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/5534764570.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Marcela R. López Ramos</li>
                     <li>maraq172015@gmail.com</li>
                     <li>Tel. 5534764570</li>
                     <li>Ciudad de México</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
         
         
         
         

       
     </div>
 </div>
